export default {
    usuarios: [],
    usuariosAuth: [],
    usersLoaded: false,
    roles: [
        {
            text: 'Cliente',
            value: 'cliente'
        },
        {
            text: 'Dueño negocio',
            value: 'boss_negocio'
        },
        {
            text: 'Dueño directorio',
            value: 'boss_directorio'
        },
        {
            text: 'Dueño restaurante',
            value: 'boss_restaurante'
        },
        {
            text: 'Partner',
            value: 'partner'
        },
        {
            text: 'Secretaría',
            value: 'secretaria'
        },
        {
            text: 'Marketing',
            value: 'marketing'
        },
        {
            text: 'Usuario TPV',
            value: 'tpv'
        },
        {
            text: 'Comandero TPV',
            value: 'tpv-comandero'
        },
        {
            text: 'Repartidor TPV',
            value: 'tpv-repartidor'
        },
        {
            text: 'Administrador',
            value: 'admin'
        },
    ],
    rolesAdmin: ['admin', 'boss_negocio', 'boss_restaurante', 'marketin', 'secretaria', 'partner'],
    usuarioViendo: null
}